var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "api-page",
    class: _vm.isMobile && 'wap'
  }, [_c('div', {
    staticClass: "api-head"
  }, [_c('m-head')], 1), _c('section', {
    staticClass: "hero"
  }, [_c('div', {
    staticClass: "hero-bg",
    style: {
      backgroundImage: `url(${_vm.heroBg})`
    }
  }), _c('div', {
    staticClass: "hero-content wrap"
  }, [_c('h1', {
    staticClass: "hero-title"
  }, [_vm._v(_vm._s(_vm.$lang("Virtual Card Services via API")))]), _c('p', {
    staticClass: "hero-sub"
  }, [_vm._v(" " + _vm._s(_vm.$lang("Integrate MPay virtual card services directly into your platform through our API."))), _c('br'), _vm._v(" " + _vm._s(_vm.$lang("MPay provides the core capabilities required to issue, fund, manage,and monitor virtual Visa cards through a secure and reliable API connection.")) + " ")])])]), _c('section', {
    staticClass: "capabilities"
  }, [_c('div', {
    staticClass: "capabilities-main wrap"
  }, [_c('div', {
    staticClass: "section-header"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v(_vm._s(_vm.$lang("API Capabilities")))])]), _c('div', {
    staticClass: "capabilities-grid"
  }, _vm._l(_vm.capabilities, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "cap-card"
    }, [_c('img', {
      staticClass: "cap-icon",
      attrs: {
        "src": item.icon,
        "alt": item.title
      }
    }), _c('h3', {
      staticClass: "cap-title"
    }, [_vm._v(_vm._s(item.title))]), _c('p', {
      staticClass: "cap-desc"
    }, [_vm._v(_vm._s(item.desc))])]);
  }), 0)])]), _c('section', {
    staticClass: "visa"
  }, [_c('div', {
    staticClass: "section-header"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v(_vm._s(_vm.$lang("Global Visa Acceptance")))])]), _c('div', {
    staticClass: "visa-content wrap"
  }, [_c('div', {
    staticClass: "visa-left"
  }, [_c('h3', {
    staticClass: "visa-left-title"
  }, [_vm._v(" " + _vm._s(_vm.$lang("Built for global spending.")) + " ")]), _c('p', {
    staticClass: "visa-left-desc"
  }, [_vm._v(" " + _vm._s(_vm.$lang("MPay virtual Visa cards can be used for online payments with a wide range of merchants worldwide that accept Visa.")) + " ")]), _c('p', {
    staticClass: "visa-left-desc xs"
  }, [_vm._v(" " + _vm._s(_vm.$lang("Supported payment scenarios may include:")) + " ")]), _vm.isMobile ? _c('div', {
    staticClass: "visa-right"
  }, [_c('img', {
    staticClass: "visa-map",
    attrs: {
      "src": _vm.worldMap,
      "alt": "Global Visa acceptance map"
    }
  })]) : _vm._e(), _c('ul', {
    staticClass: "visa-list"
  }, _vm._l(_vm.useCases, function (item, index) {
    return _c('li', {
      key: index,
      staticClass: "visa-item"
    }, [_c('span', {
      staticClass: "visa-check"
    }, [_c('svg', {
      attrs: {
        "viewBox": "0 0 24 24",
        "fill": "none",
        "aria-hidden": "true"
      }
    }, [_c('path', {
      attrs: {
        "d": "M6 12L10 16L18 8",
        "stroke": "#25D06A",
        "stroke-width": "2.5",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    })])]), _c('span', {
      staticClass: "visa-label"
    }, [_vm._v(_vm._s(item))])]);
  }), 0)]), !_vm.isMobile ? _c('div', {
    staticClass: "visa-right"
  }, [_c('img', {
    staticClass: "visa-map",
    attrs: {
      "src": _vm.worldMap,
      "alt": "Global Visa acceptance map"
    }
  })]) : _vm._e()]), _c('p', {
    staticClass: "visa-note"
  }, [_vm._v(" " + _vm._s(_vm.$lang("Actual card acceptance may vary depending on the merchant, country,transaction type, and applicable restrictions.")) + " ")])]), _c('section', {
    staticClass: "security"
  }, [_c('div', {
    staticClass: "security-main wrap"
  }, [_c('div', {
    staticClass: "section-header"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v(" " + _vm._s(_vm.$lang("Secure API Infrastructure")) + " ")]), _c('p', {
    staticClass: "section-sub"
  }, [_vm._v(" " + _vm._s(_vm.$lang("MPay API is designed with security and reliability in mind.")) + " ")])]), _c('div', {
    staticClass: "security-content"
  }, [_c('p', {
    staticClass: "security-subheading"
  }, [_vm._v(" " + _vm._s(_vm.$lang("Key technical features include")) + " ")]), _c('div', {
    staticClass: "features-grid"
  }, _vm._l(_vm.features, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "feature-card"
    }, [_c('span', {
      staticClass: "feature-dot",
      class: item.dotClass
    }), _c('span', {
      staticClass: "feature-text"
    }, [_vm._v(_vm._s(item.text))])]);
  }), 0), _c('p', {
    staticClass: "security-note"
  }, [_vm._v(" " + _vm._s(_vm.$lang("API access and available capabilities are provided according to the specific integration requirements.")) + " ")])])])]), _c('section', {
    staticClass: "cta"
  }, [_c('div', {
    staticClass: "cta-card"
  }, [_c('h2', {
    staticClass: "cta-title"
  }, [_vm._v(" " + _vm._s(_vm.$lang("Interested in Integration?")) + " ")]), _c('p', {
    staticClass: "cta-sub"
  }, [_vm._v(" " + _vm._s(_vm.$lang("If you are interested in using MPay API services, please contact us.Tell us what you are building, how you plan to use our card infrastructure, and what API capabilities you need.")) + " ")]), _c('a', {
    ref: "Copiedref",
    staticClass: "cta-email",
    on: {
      "click": _vm.onCopy
    }
  }, [_vm._v(_vm._s(_vm.contactEmail) + " "), _c('svg-icon', {
    attrs: {
      "name": "icon-copy"
    }
  })], 1), _c('a', {
    staticClass: "cta-btn",
    on: {
      "click": _vm.contactEmailFnc
    }
  }, [_vm._v(" " + _vm._s(_vm.$lang("Contact Us")) + " "), _c('svg', {
    attrs: {
      "viewBox": "0 0 16 16",
      "fill": "none",
      "aria-hidden": "true"
    }
  }, [_c('path', {
    attrs: {
      "d": "M3 8H13M9 4L13 8L9 12",
      "stroke": "#FFFFFF",
      "stroke-width": "1.8",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])])])]), _c('div', {
    staticClass: "index-footer"
  }, [_c('div', {
    staticClass: "index-footer-main wrap"
  }, [_c('div', {
    staticClass: "index-footer-logo",
    style: {
      background: `url(${require('@images/login-1.png')}) center/auto 100% no-repeat`
    }
  }), _c('div', {
    staticClass: "index-footer-share"
  }, _vm._l(_vm.share, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "index-footer-share-item",
      class: !item.type && (_vm.isMobile ? 'soon wap' : 'soon'),
      on: {
        "click": function ($event) {
          return _vm.onSkip(item.type);
        }
      }
    }, [_c('svg-icon', {
      attrs: {
        "name": item.icon
      }
    })], 1);
  }), 0)])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };